import { useContext } from 'react'

import { PreviousRouteContext } from '../contextProviders/PreviousRouteContextProvider'

/**
 * @returns url pathname of the route user was on previously.
 * - If null, the previous route is not ready. URL has just changed and previous route is currently being set.
 * - If undefined, there is no previous route.
 */
// this is copied directly from LWUI
export const usePreviousRoute = () => {
  return useContext(PreviousRouteContext).previousRoute
}
